module.exports = __webpack_public_path__ + "assets/img/SecuritiesSolutions-banner.7a04f52f.png";